import styled from 'styled-components';

const CardArea = styled.div`
    box-shadow: 0 1px 1px 0 rgba(66, 66, 66, 0.08),
        0 1px 3px 1px rgba(66, 66, 66, 0.16);
    border-radius: 4px;
    background-color: #fff;
`;

const Header = styled.div`
    padding: 18px;
`;

const Content = styled.div`
    padding: 18px;
`;

const Footer = styled.div`
    padding: 18px;
`;

export { CardArea, Content, Footer, Header };
